/**
 * ConfirmDeleteModal – Reusable delete confirmation dialog.
 */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Stack,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  itemName,
  itemType,
  loading,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) {
      e.preventDefault();
      onConfirm();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
        onKeyDown: handleKeyDown,
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, textAlign: 'center' }}>
        Delete {itemType}?
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <WarningAmberIcon sx={{ color: 'error.main', fontSize: 48 }} />
        </Box>
        <Typography color="text.secondary" textAlign="center">
          Are you sure you want to delete &quot;{itemName}&quot;? This cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', px: 3, pb: 2 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Delete {itemType}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
